<template>
  <div class="login-wrap">
    <!--<language></language>-->
    <div class="ms-login">
      <div class="ms-title">客户端登陆</div>
      <el-form :model="param" :rules="rules" ref="login" label-width="0px" class="ms-content">
        <el-form-item prop="username">
          <el-input v-model="param.username" placeholder="username">
            <el-button slot="prepend" icon="el-icon-user"></el-button>
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            type="password"
            placeholder="password"
            v-model="param.password"
            @keyup.enter.native="submitForm()"
          >
            <el-button slot="prepend" icon="el-icon-lock"></el-button>
          </el-input>
        </el-form-item>
        <div class="login-btn">
          <el-button type="primary" @click="submitForm()">登陆</el-button>
          <!--<el-button type="success" @click="register()">注册</el-button>-->
        </div>
        <!--<p class="login-tips">Tips : 用户名和密码随便填。</p>-->
      </el-form>
    </div>
  </div>
</template>

<script>
// import language from "@/components/Language";
import {mapState, mapMutations} from 'vuex';

export default {
  name: "login",
  components: {
    // language
  },
  data: function () {
    return {
      param: {
        username: '',
        password: '',
      },
      rules: {
        username: [{required: true, message: '请输入登陆账号', trigger: 'blur'}],
        password: [{required: true, message: '请输入登陆密码', trigger: 'blur'}],
      },
    };
  },
  computed: {
    ...mapState(['access_token']),
  },
  methods: {
    ...mapMutations(['setLogin','setUserInfo']),
    submitForm() {
      this.$refs.login.validate(valid => {
        if (valid) {
          this.http.fetchPost(this.api.login, this.param).then((res) => {
            var data = res.data;
            console.log(data.code)
            if (data.code === 200) {
              // var access_token = data.data.access_token;
              // this.setLogin(access_token);
              this.getUserInfo()
              // this.$message.success('登陆成功');
              this.$message({
                showClose: true,
                message: '登陆成功',
                type: 'success'
              });
              this.$router.back() //后退
              // this.$router.push('/');
            } else {
              this.$message.error(data.message);
            }
            // 请求成功处理
          }).catch(err => {
            console.log(err)
          })

        } else {
          // this.$message.error('请输入账号和密码');
          console.log('error submit!!');
          return false;
        }
      });
    },

    getUserInfo(){
      this.http.fetchGet(this.api.user_info).then((res)=>{
          if(res.data.status==0){
            //强制下线
            this.setLogout();
            this.$router.push('/login');
          }
          var data=res.data;
          this.setUserInfo(data);
        }
      ).catch(err => {
        console.log(err)
      })
    },

    register() {
      this.$router.push('/register')
    }
  },
}
</script>

<style scoped lang="stylus">

.login-wrap {
  position: relative;
  width: 100%;
  height: 100%;
  /*background-image: url(../../assets/img/login-bg.jpg);*/
  background-size: 100%;
  background-color: #eeeeee;
}

.ms-title {
  width: 100%;
  line-height: 50px;
  text-align: center;
  font-size: 20px;
  color: #393d49;
  border-bottom: 1px solid #ddd;
}

.ms-login {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 350px;
  margin: -190px 0 0 -175px;
  border-radius: 5px;
  background: rgba(255, 255, 255, 0.3);
  overflow: hidden;
}

.ms-content {
  padding: 30px 30px;
}

.login-btn {
  text-align: center;
  display flex
  justify-content space-between

}

.login-btn button {
  /*display:flex*/
  /*float left*/
  width: 100%;
  height: 36px;
  margin-bottom: 10px;
}

.login-tips {
  font-size: 12px;
  line-height: 30px;
  color: #393d49;
}

</style>
